import { useQuery } from 'react-query';
import CountryService from '../../services/CountryService';

const LoadCountries = () => {
  return useQuery(
    'countries',
    async () => {
      const response = await CountryService.getCountries();
      return response;
    },
    {
      staleTime: 300000, // 5 minutes
      cacheTime: 600000, // 10 minutes
      onError: (error) => {
        console.error('Failed to load countries:', error);
      }
    }
  );
};

export default LoadCountries;
